import { Loader2 } from "lucide-react";
import { Input as BaseInput } from "../shadcn/Input";
import { InputHTMLAttributes, forwardRef } from "react";
import { cn } from "../../utils/css";

export const Input = forwardRef<
  HTMLInputElement,
  InputHTMLAttributes<HTMLInputElement> & {
    isLoading?: boolean;
    wrapperClassName?: string;
  }
>(({
  isLoading = false,
  wrapperClassName = "flex-1",
  className,
  ...props
}, ref) => {
  return (
    <div className={`relative ${wrapperClassName}`}>
      <BaseInput ref={ref} {...props} className={cn(className, isLoading && "pr-10")} />
      {isLoading && (
        <span className="absolute right-3 top-1/2 transform -translate-y-1/2">
          <Loader2 className="animate-spin h-5 w-5 text-gray-500" />
        </span>
      )}
    </div>
  );
});

Input.displayName = "Input";
